var $80774f770f9195e5$exports = {};
$80774f770f9195e5$exports = {
    "loading": `\u{141}adowanie...`,
    "placeholder": `Zaznacz\u{2026}`
};


export {$80774f770f9195e5$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
